import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import '../Styles/components/BackB.css'; 

function BackB() {
  const location = useLocation();

  const isAdminHome = matchPath("/AdminHome/:UID", location.pathname);
  const isSapakimHome = matchPath("/SapakimHome/:UID", location.pathname);

  if (isAdminHome || isSapakimHome) return null;

  return (
    <div className="backB">
      <button onClick={() => window.history.back()}>
        <FaArrowLeft style={{ marginRight: '5px' }} />
      </button>
    </div>
  );
}

export default BackB;
